import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Modal from '../../Modal/Modal';

import StepByStep from '../../StepByStep';
import EditSecurityQuestion from './EditSecurityQuestion/EditSecurityQuestion';
import Status from '../Status';

const steps = [EditSecurityQuestion, Status];
const ChangeSecurityQuestionModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const [error, setError] = useState('');

  return (
    <>
      <Modal
        title={t('profileSettings.changeSecurityQuestion')}
        isOpen={isOpen}
        close={onClose}
        size="sm"
        closeIconVisible
      >
        <StepByStep saveStepDisabled>
          {({ goStepForward, goStepBack }) =>
            steps.map((step) =>
              React.createElement(step, {
                handleBack: goStepBack,
                handleNext: goStepForward,
                handleClose: onClose,
                backButtonText: t('common.ok'),
                onButtonClick: onClose,
                setError,
                text: error || t('profileSettings.securityQuestionChanged'),
                hasError: error,
              }),
            )
          }
        </StepByStep>
      </Modal>
    </>
  );
};

ChangeSecurityQuestionModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ChangeSecurityQuestionModal;
